// ModalCarrinho.js — Toast exibido ao adicionar um item ao carrinho.
// Aparece no canto superior-direito, logo abaixo do header fixo (usa --nav-h),
// com card temático (acompanha claro/escuro), borda navy e CTAs.
import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useModal } from "../../services/context/ModalContext";
import { CarrinhoContext } from "../../services/context/CarrinhoContext";

const fmt = (v) => (parseFloat(v) || 0).toFixed(2).replace(".", ",");

const ModalCarrinho = () => {
  const { modalData, closeModal } = useModal();
  const { totalItens, valorTotal } = useContext(CarrinhoContext);
  const API_URL = process.env.REACT_APP_API;
  const main = process.env.REACT_APP_MAIN;

  // Fecha sozinho após 4s (tempo de ler e clicar nos botões)
  useEffect(() => {
    if (!modalData) return;
    const t = setTimeout(() => closeModal(), 4000);
    return () => clearTimeout(t);
  }, [modalData, closeModal]);

  if (!modalData) return null;

  return (
    <div
      role="alert"
      style={{ top: "calc(var(--nav-h) + 12px)" }}
      className="cart-toast fixed right-3 sm:right-4 z-[10001]
                 w-[calc(100vw-1.5rem)] max-w-[360px]
                 rounded-2xl overflow-hidden bg-insigne-navy-soft
                 border border-line shadow-[0_16px_48px_rgba(0,0,0,0.4)]"
    >
      {/* Cabeçalho de sucesso */}
      <div className="flex items-center gap-2 px-4 py-2.5 bg-insigne-orange/15 border-b border-line">
        <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-emerald-500 text-paper text-xs">
          <i className="bi bi-check-lg" />
        </span>
        <span className="text-white font-bold text-sm flex-1">Adicionado ao carrinho!</span>
        <button
          onClick={closeModal}
          aria-label="Fechar"
          className="w-7 h-7 rounded-full text-white/70 hover:text-white hover:bg-white/10
                     flex items-center justify-center transition-colors shrink-0"
        >
          <i className="bi bi-x text-lg" />
        </button>
      </div>

      {/* Produto adicionado */}
      <div className="flex gap-3 p-4">
        <div className="w-16 h-20 shrink-0 rounded-lg overflow-hidden bg-insigne-navy-deep flex items-center justify-center">
          {modalData.image ? (
            <img
              src={`${API_URL}public/${modalData.image}`}
              alt={modalData.titulo}
              className="w-full h-full object-cover"
              onError={(e) => { e.target.style.display = "none"; }}
            />
          ) : (
            <i className="bi bi-book text-white/30 text-xl" />
          )}
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-white font-semibold text-sm leading-snug line-clamp-2">
            {modalData.titulo || "Produto"}
          </p>
          <p className="text-white/60 text-xs mt-1">
            1× <span className="text-insigne-orange font-bold">R$ {fmt(modalData.preco)}</span>
          </p>
        </div>
      </div>

      {/* Total + ações */}
      <div className="px-4 pb-4">
        <div className="flex items-center justify-between text-sm border-t border-line pt-3">
          <span className="text-white/70">
            Total ({totalItens} {totalItens === 1 ? "item" : "itens"})
          </span>
          <span className="text-white font-bold">R$ {fmt(valorTotal)}</span>
        </div>
        <div className="flex gap-2 mt-3">
          <button
            onClick={closeModal}
            className="flex-1 py-2 rounded-lg text-xs font-semibold text-white
                       border border-line hover:bg-white/5 transition-colors"
          >
            Continuar
          </button>
          <Link
            to={main + "carrinho"}
            onClick={closeModal}
            className="flex-1 py-2 rounded-lg text-xs font-bold uppercase text-center text-paper
                       bg-insigne-orange hover:bg-insigne-orange-dark transition-colors"
          >
            Ver carrinho
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ModalCarrinho;
